import type { LucideIcon } from 'lucide-react';
import { PageHeader } from './PageHeader';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { EmptyState } from '@/components/ui/EmptyState';

interface PhaseStubPageProps {
  title: string;
  phase: 2 | 3 | 4 | 5 | 6;
  modules: string[];
  icon: LucideIcon;
}

/**
 * Reusable scaffold for Phase 2-6 pages whose schema + RLS is in place but
 * whose UI is still under construction. Renders the brand-flavored empty
 * state, the planned modules, and a phase badge so users know what's coming.
 */
export function PhaseStubPage({ title, phase, modules, icon }: PhaseStubPageProps) {
  return (
    <div className="space-y-6">
      <PageHeader
        title={title}
        actions={<Badge variant="info">Phase {phase}</Badge>}
      />
      <Card>
        <CardHeader>
          <CardTitle>Planned scope</CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="grid gap-2 sm:grid-cols-2">
            {modules.map((m) => (
              <li
                key={m}
                className="rounded-md border border-border bg-secondary/40 px-3 py-2 text-sm text-foreground"
              >
                {m}
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>

      <EmptyState
        icon={icon}
        title="UI under construction"
      />
    </div>
  );
}
